import ApiServiceBase from "@/services/api/apiServiceBase";
import {Preferences} from "@capacitor/preferences";

export enum FeedPreference {
    Kinks = 'KINKS',
    Interests = 'INTERESTS',
    Gender = 'GENDER',
    Body = 'BODY',
    Drinking = 'DRINKING',
    Religion = 'RELIGION',
    Sexuality = 'SEXUALITY',
    Smoking = 'SMOKING',
    Piercings = 'PIERCINGS',
    Tattoos = 'TATTOOS',
    Relationship = 'RELATIONSHIP',
    Distance = 'DISTANCE',
}

const API_KEY_PREFIX = 'FEED_';

function toApiKey(key: FeedPreference | string): string {
    const raw = String(key);
    if (raw.startsWith(API_KEY_PREFIX)) return raw;
    return `${API_KEY_PREFIX}${raw}`;
}

export class FeedPreferencesService extends ApiServiceBase {

    private preferencesKey = 'FEED_PREFERENCES';

    public async set(key: FeedPreference, value: any): Promise<any> {
        const preferences = {[toApiKey(key)]: value};
        const updated = await this.http?.post('/feed/preferences', {preferences});
        await Preferences.set({key: this.preferencesKey, value: JSON.stringify(updated)});
        return updated;
    }

    private async fetchAndCache() {
        const preferences = await this.http?.get('/feed/preferences');
        await Preferences.set({key: this.preferencesKey, value: JSON.stringify(preferences)});
        return preferences;
    }

    public async get(fresh = false): Promise<any> {
        if (fresh) return this.fetchAndCache();

        const preferences = (await Preferences.get({key: this.preferencesKey})).value;
        if (preferences) return JSON.parse(preferences);

        return this.fetchAndCache();
    }

    public async setMany(preferences: Record<string, any>): Promise<any> {
        const mapped: Record<string, any> = {};
        for (const [key, value] of Object.entries(preferences)) {
            mapped[toApiKey(key)] = value;
        }
        const updated = await this.http?.post('/feed/preferences', {preferences: mapped});
        await Preferences.set({key: this.preferencesKey, value: JSON.stringify(updated)});
        return updated;
    }
}
